import { Link } from "react-router-dom";
import type { Work } from "@/types/content";

const typeStyle: Record<string, string> = {
  电影: "bg-accent-500 text-background-50",
  电视剧: "bg-secondary-600 text-background-50",
  短片: "bg-primary-600 text-background-50",
};

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} - 奥田咲影视作品海报`}
          title={`${work.title} 奥田咲影视作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium ${typeStyle[work.type] || "bg-primary-600 text-background-50"}`}
        >
          {work.type}
        </span>
        <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-black/45 text-white text-xs backdrop-blur">
          <i className="ri-star-fill text-accent-300"></i>
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-3.5">
          <h3 className="font-heading text-base font-bold text-white leading-snug line-clamp-2">
            {work.title}
          </h3>
          <div className="mt-1.5 flex items-center gap-2 text-xs text-white/75">
            <span>{work.year}</span>
            <span className="w-1 h-1 rounded-full bg-white/50"></span>
            <span className="truncate">{work.role}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}